// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/watch.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services {
  width: 100%;
  background-color: white;
  padding: 203px 0 193px 0;
  color: rgba(144, 110, 103, 1);
}

.services__all-container {
  max-width: 1386px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 0;
}

.services__header-container {
  display: flex;
  margin: 0 0 74px auto;
}

.services__header-line {
  height: 1px;
  width: 450px;
  background-color: rgba(144, 110, 103, 1);
  margin: 40px 30px 10px 0;
}

.services__header {
  margin: 0;
  padding: 0;
  font-family: "Playfair Display";
  font-size: 60px;
  font-weight: 500;
  line-height: 50px;
}

.services__item {
  display: flex;
  max-width: 938px;
  width: 100%;
  border-top: 1px solid rgba(144, 110, 103, 1);
  border-bottom: 1px solid rgba(144, 110, 103, 1);
}

.services__item:nth-of-type(2n) {
  margin: 0 auto 73px 0;
}

.services__item:nth-of-type(2n + 1) {
  margin: 0 0 73px auto;
}

.services__item:last-of-type {
  margin-bottom: 0;
}

.services__service {
  max-width: 495px;
  font-family: "Playfair Display";
  font-size: 30px;
  font-weight: 500;
  line-height: 40px;
  margin: 55px 94px 55px 114px;
  padding: 0;
}

.services__price {
  font-family: "Playfair Display";
  font-size: 30px;
  font-weight: 500;
  line-height: 40px;
  margin: auto 25px auto 0;
}

.services__length {
  display: flex;
}

.services__watch-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 24px;
  height: 24px;
  background-repeat: 0;
  margin: auto 12px auto 0;
}

.services__duration {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  margin: 0;
}

@media screen and (max-width: 1439px) {
  .services {
    padding: 100px 0 100px 0;
  }

  .services__all-container {
    max-width: 984px;
  }

  .services__header-container {
    margin: 0 0 40px auto;
  }

  .services__header-line {
    width: 387px;
  }

  .services__header {
    font-size: 45px;
    line-height: 55px;
  }

  .services__item,
  .services__item:nth-of-type(2n),
  .services__item:nth-of-type(2n + 1) {
    max-width: 984px;
    margin: 0 auto 40px auto;
  }

  .services__item:last-of-type {
    margin-bottom: 0;
  }

  .services__service {
    font-size: 26px;
    line-height: 36px;
    margin: 42px auto 63px 0px;
    padding: 0;
  }

  .services__price {
    font-size: 26px;
    line-height: 36px;
    margin: auto 0 auto 0;
  }

  .services__duration {
    font-size: 18px;
    line-height: 26px;
  }
}

@media screen and (max-width: 1023px) {
  .services {
    padding: 75px 0 75px 0;
  }

  .services__all-container {
    max-width: 708px;
  }

  .services__header {
    font-size: 35px;
    line-height: 45px;
  }

  .services__header-line {
    margin: 25px 15px 10px 0;
  }

  .services__service {
    font-size: 22px;
    line-height: 32px;
    margin: 42px auto 42px 0px;
  }

  .services__price {
    font-size: 22px;
    line-height: 32px;
  }

  .services__duration {
    font-size: 16px;
    line-height: 24px;
  }
}

@media screen and (max-width: 763px) {
  .services {
    padding: 86px 0 86px 0;
  }

  .services__all-container {
    max-width: 320px;
  }

  .services__header-container {
    margin: 0 0 66px auto;
  }

  .services__header-line {
    width: 151px;
    margin: 22px 54px 10px 0;
  }

  .services__header {
    font-size: 36px;
    line-height: 34px;
  }

  .services__item {
    max-width: 320px;
    flex-direction: column;
  }

  .services__item:nth-of-type(2n) {
    margin: 0 auto 40px 0;
  }

  .services__item:nth-of-type(2n + 1) {
    margin: 0 auto;
    margin-bottom: 42px;
  }

  .services__service {
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    margin: 20px auto 20px 0;
  }

  .services__price {
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    margin: 0 auto 20px 0;
  }

  .services__watch-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 24px;
    height: 24px;
    background-repeat: 0;
    margin: auto 12px auto 0;
  }

  .services__duration {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Services/Services.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yDAA+C;EAC/C,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;;IAGE,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,yDAA+C;IAC/C,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".services {\r\n  width: 100%;\r\n  background-color: white;\r\n  padding: 203px 0 193px 0;\r\n  color: rgba(144, 110, 103, 1);\r\n}\r\n\r\n.services__all-container {\r\n  max-width: 1386px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0 auto;\r\n  padding: 0;\r\n}\r\n\r\n.services__header-container {\r\n  display: flex;\r\n  margin: 0 0 74px auto;\r\n}\r\n\r\n.services__header-line {\r\n  height: 1px;\r\n  width: 450px;\r\n  background-color: rgba(144, 110, 103, 1);\r\n  margin: 40px 30px 10px 0;\r\n}\r\n\r\n.services__header {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: \"Playfair Display\";\r\n  font-size: 60px;\r\n  font-weight: 500;\r\n  line-height: 50px;\r\n}\r\n\r\n.services__item {\r\n  display: flex;\r\n  max-width: 938px;\r\n  width: 100%;\r\n  border-top: 1px solid rgba(144, 110, 103, 1);\r\n  border-bottom: 1px solid rgba(144, 110, 103, 1);\r\n}\r\n\r\n.services__item:nth-of-type(2n) {\r\n  margin: 0 auto 73px 0;\r\n}\r\n\r\n.services__item:nth-of-type(2n + 1) {\r\n  margin: 0 0 73px auto;\r\n}\r\n\r\n.services__item:last-of-type {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.services__service {\r\n  max-width: 495px;\r\n  font-family: \"Playfair Display\";\r\n  font-size: 30px;\r\n  font-weight: 500;\r\n  line-height: 40px;\r\n  margin: 55px 94px 55px 114px;\r\n  padding: 0;\r\n}\r\n\r\n.services__price {\r\n  font-family: \"Playfair Display\";\r\n  font-size: 30px;\r\n  font-weight: 500;\r\n  line-height: 40px;\r\n  margin: auto 25px auto 0;\r\n}\r\n\r\n.services__length {\r\n  display: flex;\r\n}\r\n\r\n.services__watch-icon {\r\n  background-image: url(\"../../images/watch.svg\");\r\n  width: 24px;\r\n  height: 24px;\r\n  background-repeat: 0;\r\n  margin: auto 12px auto 0;\r\n}\r\n\r\n.services__duration {\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  line-height: 28px;\r\n  margin: 0;\r\n}\r\n\r\n@media screen and (max-width: 1439px) {\r\n  .services {\r\n    padding: 100px 0 100px 0;\r\n  }\r\n\r\n  .services__all-container {\r\n    max-width: 984px;\r\n  }\r\n\r\n  .services__header-container {\r\n    margin: 0 0 40px auto;\r\n  }\r\n\r\n  .services__header-line {\r\n    width: 387px;\r\n  }\r\n\r\n  .services__header {\r\n    font-size: 45px;\r\n    line-height: 55px;\r\n  }\r\n\r\n  .services__item,\r\n  .services__item:nth-of-type(2n),\r\n  .services__item:nth-of-type(2n + 1) {\r\n    max-width: 984px;\r\n    margin: 0 auto 40px auto;\r\n  }\r\n\r\n  .services__item:last-of-type {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .services__service {\r\n    font-size: 26px;\r\n    line-height: 36px;\r\n    margin: 42px auto 63px 0px;\r\n    padding: 0;\r\n  }\r\n\r\n  .services__price {\r\n    font-size: 26px;\r\n    line-height: 36px;\r\n    margin: auto 0 auto 0;\r\n  }\r\n\r\n  .services__duration {\r\n    font-size: 18px;\r\n    line-height: 26px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1023px) {\r\n  .services {\r\n    padding: 75px 0 75px 0;\r\n  }\r\n\r\n  .services__all-container {\r\n    max-width: 708px;\r\n  }\r\n\r\n  .services__header {\r\n    font-size: 35px;\r\n    line-height: 45px;\r\n  }\r\n\r\n  .services__header-line {\r\n    margin: 25px 15px 10px 0;\r\n  }\r\n\r\n  .services__service {\r\n    font-size: 22px;\r\n    line-height: 32px;\r\n    margin: 42px auto 42px 0px;\r\n  }\r\n\r\n  .services__price {\r\n    font-size: 22px;\r\n    line-height: 32px;\r\n  }\r\n\r\n  .services__duration {\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 763px) {\r\n  .services {\r\n    padding: 86px 0 86px 0;\r\n  }\r\n\r\n  .services__all-container {\r\n    max-width: 320px;\r\n  }\r\n\r\n  .services__header-container {\r\n    margin: 0 0 66px auto;\r\n  }\r\n\r\n  .services__header-line {\r\n    width: 151px;\r\n    margin: 22px 54px 10px 0;\r\n  }\r\n\r\n  .services__header {\r\n    font-size: 36px;\r\n    line-height: 34px;\r\n  }\r\n\r\n  .services__item {\r\n    max-width: 320px;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .services__item:nth-of-type(2n) {\r\n    margin: 0 auto 40px 0;\r\n  }\r\n\r\n  .services__item:nth-of-type(2n + 1) {\r\n    margin: 0 auto;\r\n    margin-bottom: 42px;\r\n  }\r\n\r\n  .services__service {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    line-height: 26px;\r\n    margin: 20px auto 20px 0;\r\n  }\r\n\r\n  .services__price {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    line-height: 26px;\r\n    margin: 0 auto 20px 0;\r\n  }\r\n\r\n  .services__watch-icon {\r\n    background-image: url(\"../../images/watch.svg\");\r\n    width: 24px;\r\n    height: 24px;\r\n    background-repeat: 0;\r\n    margin: auto 12px auto 0;\r\n  }\r\n\r\n  .services__duration {\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    line-height: 24px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
